import {MobileBasePage} from './mobile-base-page';
import {HostListener, Injectable, Injector} from '@angular/core';
import {Category, Item, OrderManager, Store} from 'aigens-ng-core';
import {RouteTable} from '../route-table';
import {Observable} from 'rxjs';
import { DecimalPipe } from '@angular/common';
@Injectable()
export abstract class BaseCategoryListPage extends MobileBasePage {

    store: Store;
    storeId: number;
    isBounce = false;

    userTypes: string[] = [];
    marker: any = [];

    // cache
    modifiableMap = {};

    protected constructor(injector: Injector) {

        super(injector);
        console.log('BaseCategoryListPage');
        const store = this.getNavParamsOrParams('store');
        const storeId = this.getNavParamsOrParams('storeId');
        // this.orderManager.clear();

        if (store) {
            this.store = store;
            this.storeId = store.id;
        } else if (storeId) {
            this.storeId = storeId;
        }

        if (this.multOrderManager.enableMutlOrder) {
            this.settingMultiOrderManager();
        } else if (this.orderManager.isEmpty()) {
            this.orderManager.createOrder(this.storeId, null, null, this.orderManager.mode, this.store);
            let member = this.memberService.getMember();
            if (member) {
                this.userTypes.push('member');
                this.orderManager.setUserPoints(member);
            }
            if (this.marker && this.marker.length > 0) {
                for (let marker of this.marker) {
                    this.userTypes.push(marker);
                }

            }
        }
        // set in byodSplash
        this.orderManager.settingOrderType(this.orderManager.mode);
        // this.initSharingCart();
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> {
        console.log('guard running');
        // this.navigationService.deactivateResult.next(false);
        if (!this.navigationService.poping) {
            // this.navController.setDirection('back', true, 'back');
            return Observable.of(true);
        }
        if (this.multOrderManager.enableMutlOrder) {
            return Observable.of(true);
        }
        if (this.orderManager.isEmpty()) { // 购物车为空的时候
            return Observable.of(true);
        }
        // Allow synchronous navigation (`true`) if no crisis or the crisis is unchanged
        try {
            console.log('creating alert?', this.navigationService.isAlertingDeactive);
            if (!this.navigationService.isAlertingDeactive) {
                this.navigationService.isAlertingDeactive = true;
                const alert = this.alertController.create({
                    header: this.t.instant('pages.brand-store-list.alert-title'),
                    backdropDismiss: false,
                    buttons: [
                        {
                            text: this.t.instant('buttons.cancel'),
                            handler: () => {
                                // to do
                                // this.googleAnalyticEventTrack('back-button-event', 'cancel');
                                this.navigationService.isAlertingDeactive = false;
                                this.navigationService.poping = false;
                                this.navController.setDirection('forward', true, 'forward');
                                window.history.pushState({}, 'Order.Place', window.location.href);
                                // TODO: the history is still popped even the navigation is cancelled so we push it back to history stack.
                                console.log('push state', window.location.href);
                                this.navigationService.deactivateResult.next(false);
                                // this.navigationService.deactivateResult.complete();
                            }
                        },
                        {
                            text: this.t.instant('buttons.leave'),
                            handler: () => {
                                // to do
                                // this.googleAnalyticEventTrack('back-button-event', 'back');
                                const key = this.storeId + '.savedOrder';
                                this.configService.putPreference(key, null);
                                this.navigationService.isAlertingDeactive = false;
                                this.navigationService.deactivateResult.next(true);
                                // this.navigationService.deactivateResult.complete();
                                // super.backButtonClick();
                                // return 'ok';
                            }
                        }
                    ]
                });
                console.log('make alert');

                alert.then((data) => {

                    console.log('alert created', data);
                    console.log('alert created', this);
                    data.present().then((success) => {
                        console.log('success', success);
                    }, (reject) => {
                        console.log('reject', reject);
                    });
                });
            }

        } catch (e) {
            console.error(e);
        }

        return this.navigationService.deactivateResult;
    }
    getNavParamsOrParams(key: string): any {
        return this.getNavParams(key) ? this.getNavParams(key) : this.navigationService.getNavigationParams()[key];
    }
    settingMultiOrderManager() {
        if (this.multOrderManager.getOrderManager(this.storeId)) {
            let mode = this.orderManager.mode;
            this.orderManager = this.multOrderManager.getOrderManager(this.storeId);
            this.orderManager.mode = mode;
        } else {
            const orderManager = new OrderManager();
            orderManager.mode = this.orderManager.mode;
            orderManager.createOrder(this.storeId, null, null, this.orderManager.mode, this.store);
            this.addCourtReward(orderManager);
            this.multOrderManager.setOrderManagerMap(orderManager, this.storeId);
            this.orderManager = this.multOrderManager.getOrderManager(this.storeId);

        }
    }

    initSharingCart() {
        if (this.orderManager.mode === 'byod') {
            this.memberService.initMember('anno');
            this.cartService.initSharingCart(this.storeId, Number.parseInt(this.orderService.spot));
        }
    }

    cartClicked() {
        console.log('on cart clicked');
        this.googleAnalyticEventTrack('shopping cart');
        if (this.multOrderManager.enableMutlOrder && this.multOrderManager.getOrderCount() > 0) {
            this.pushByUrl(RouteTable['MultiOrderCartPage']);
        } else if (!this.multOrderManager.enableMutlOrder && !this.orderManager.isEmpty()) {
            this.pushByName('CartScrollPage', {}, {relativeTo: this.route.root.firstChild});
        } else {
            const subtitle = this.t.instant('global.order-first');
            const confirm = this.t.instant('buttons.ok');
            const alert = this.alertController.create({
                subHeader: subtitle,
                buttons: [confirm]
            });
            alert.then(data => data.present());
        }
    }

    getImage(data: Item) {
        return data.getImage('default', 200, true);
    }
    bounce() {
        this.isBounce = true;
        setTimeout(() => {
            this.isBounce = false;
        }, 400);
    }

    getCurrentTotalPrice() {
        if (this.multOrderManager.enableMutlOrder) {
            return this.multOrderManager.getOrderTotal();
        } else {
            return this.orderManager.order.total;
        }

    }

    isSetItem(item: Item, cat: Category) {

        return Item.isSet(cat, item);
    }


    // enable cache
    isModifiable(item: Item): boolean {
        if (!this.modifiableMap[item.id]) {
            this.modifiableMap[item.id] = Item.isModifiable(item);
        }
        return this.modifiableMap[item.id];
    }

    isParent(item: Item) {

        return !!(item.variations && item.variations.length > 0);

    }

    public abstract showStore(store: Store);
}






